import React from 'react';

export const AppLoader = (props) => {
    return(
        <div className="container mx:auto mt-5">
            <p className="text-center">Loading {props.title}...</p>
        </div>
    )
}
